import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          本周必看的擦边电影未删减版完整版精选
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group bg-background-100 border border-background-200/70 hover:border-primary-400/30 rounded-lg overflow-hidden transition-colors cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={card.imageUrl}
                  alt={`${card.title} 未删减版在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-1 rounded bg-primary-500/90 text-background-50 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors mb-1.5">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}